import React from 'react';
import { TouchTargetProps } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { TertiaryButton } from 'apps/sigma2-ui/src/components/TertiaryButton';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

type EditRubricRemoveButtonProps = Pick<TouchTargetProps, 'behavior'>;

const EditRubricRemoveButtonIcon: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g>
        <path
          d="M12.9974 5H2.9974C2.90899 5 2.82421 5.03512 2.76169 5.09763C2.69918 5.16014 2.66406 5.24493 2.66406 5.33333V14.6667C2.66406 15.0203 2.80454 15.3594 3.05459 15.6095C3.30464 15.8595 3.64377 16 3.9974 16H11.9974C12.351 16 12.6902 15.8595 12.9402 15.6095C13.1903 15.3594 13.3307 15.0203 13.3307 14.6667V5.33333C13.3307 5.24493 13.2956 5.16014 13.2331 5.09763C13.1706 5.03512 13.0858 5 12.9974 5ZM6.83073 13.6667C6.83073 13.7993 6.77805 13.9265 6.68428 14.0202C6.59051 14.114 6.46334 14.1667 6.33073 14.1667C6.19812 14.1667 6.07094 14.114 5.97718 14.0202C5.88341 13.9265 5.83073 13.7993 5.83073 13.6667V7.66667C5.83073 7.53406 5.88341 7.40688 5.97718 7.31311C6.07094 7.21935 6.19812 7.16667 6.33073 7.16667C6.46334 7.16667 6.59051 7.21935 6.68428 7.31311C6.77805 7.40688 6.83073 7.53406 6.83073 7.66667V13.6667ZM10.1641 13.6667C10.1641 13.7993 10.1114 13.9265 10.0176 14.0202C9.92385 14.114 9.79667 14.1667 9.66406 14.1667C9.53145 14.1667 9.40428 14.114 9.31051 14.0202C9.21674 13.9265 9.16406 13.7993 9.16406 13.6667V7.66667C9.16406 7.53406 9.21674 7.40688 9.31051 7.31311C9.40428 7.21935 9.53145 7.16667 9.66406 7.16667C9.79667 7.16667 9.92385 7.21935 10.0176 7.31311C10.1114 7.40688 10.1641 7.53406 10.1641 7.66667V13.6667Z"
          fill={fillColor}
        />
        <path
          d="M14.6641 2.66667H11.4974C11.4532 2.66667 11.4108 2.64911 11.3795 2.61785C11.3483 2.5866 11.3307 2.5442 11.3307 2.5V1.66667C11.3307 1.22464 11.1551 0.800716 10.8426 0.488155C10.53 0.175595 10.1061 0 9.66406 0L6.33073 0C5.8887 0 5.46478 0.175595 5.15222 0.488155C4.83966 0.800716 4.66406 1.22464 4.66406 1.66667V2.5C4.66406 2.5442 4.6465 2.5866 4.61525 2.61785C4.58399 2.64911 4.5416 2.66667 4.4974 2.66667H1.33073C1.15392 2.66667 0.984349 2.7369 0.859325 2.86193C0.7343 2.98695 0.664063 3.15652 0.664062 3.33333C0.664063 3.51014 0.7343 3.67971 0.859325 3.80474C0.984349 3.92976 1.15392 4 1.33073 4H14.6641C14.8409 4 15.0104 3.92976 15.1355 3.80474C15.2605 3.67971 15.3307 3.51014 15.3307 3.33333C15.3307 3.15652 15.2605 2.98695 15.1355 2.86193C15.0104 2.7369 14.8409 2.66667 14.6641 2.66667ZM5.9974 2.5V1.66667C5.9974 1.57826 6.03252 1.49348 6.09503 1.43096C6.15754 1.36845 6.24232 1.33333 6.33073 1.33333H9.66406C9.75247 1.33333 9.83725 1.36845 9.89976 1.43096C9.96228 1.49348 9.9974 1.57826 9.9974 1.66667V2.5C9.9974 2.5442 9.97984 2.5866 9.94858 2.61785C9.91732 2.64911 9.87493 2.66667 9.83073 2.66667H6.16406C6.14218 2.66667 6.1205 2.66236 6.10028 2.65398C6.08006 2.6456 6.06169 2.63333 6.04621 2.61785C6.03074 2.60237 6.01846 2.584 6.01008 2.56378C6.00171 2.54356 5.9974 2.52189 5.9974 2.5Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export const EditRubricRemoveButton: React.FC<EditRubricRemoveButtonProps> = ({
  behavior,
}) => {
  const language = useLanguage();
  return (
    <TertiaryButton
      label={language.editRubricRemoveButtonLabel()}
      icon={<EditRubricRemoveButtonIcon />}
      behavior={behavior}
      typographyClassName="text-xs"
    />
  );
};
